export default __webpack_public_path__ + "static/media/washupStamp.86771eaa.png";